module.exports = __webpack_public_path__ + "img/7_55.4084048f.png";